import type { Product } from '../../types';
import ProductCard from './ProductCard';
import SectionHeading from './SectionHeading';

interface ProductSectionProps {
  id: string;
  overline: string;
  title: string;
  description: string;
  products: Product[];
}

const ProductSection = ({ id, overline, title, description, products }: ProductSectionProps) => {
  return (
    <section className="section container" id={id}>
      <SectionHeading overline={overline} title={title} description={description} />
      <div className="product-grid">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
};

export default ProductSection;
